import { Pipe, PipeTransform } from '@angular/core'
import { SubjectContactEntity, SubjectContactResponseDto } from '../../../api/backend'
import { CpCeEnum } from '../../cadastral/enums/subjects.enum'

@Pipe({
    name: 'displayAddress',
    standalone: false
})
export class DisplayAddressPipe implements PipeTransform {
    transform(subject: SubjectContactEntity|SubjectContactResponseDto, type?: string): string {
        if (!subject) {
            return ''
        }

        //pro SJM subjekty, ktere nemaji udaje u sebe
        //je nutne vzit udaje z contact atributu
        // @ts-ignore
        if (subject.opsubType === 'SJM' && subject.contact) {
            // @ts-ignore
            subject = subject.contact
        }

        let words = []
        let houseNumber = ''

        if (subject.ulice || subject.castObce || subject.cisloDomovni || subject.cisloOrientacni || (subject.obec && !subject.uliceKompletni)) {
            let ul = ''

            if (subject.ulice) {
                ul += subject.ulice
            } else if (subject.castObce) {
                ul += subject.castObce
            } else if (subject.obec) {
                ul += subject.obec
            }

            if (subject.cisloDomovni && !subject.cisloOrientacni) {
                houseNumber += ' ' + subject.cisloDomovni
            }
            if (!subject.cisloDomovni && subject.cisloOrientacni) {
                houseNumber += ' ' + subject.cisloOrientacni
            }
            if (subject.cisloDomovni && subject.cisloOrientacni) {
                houseNumber += ' ' + subject.cisloDomovni + '/' + subject.cisloOrientacni
            }
            // @ts-ignore
            if (!subject.cisloDomovni && !subject.cisloOrientacni && subject.cisloCele) {
                // @ts-ignore
                houseNumber += ' ' + subject.cisloCele
            }

            if(houseNumber && subject.cpCe === CpCeEnum.cisloEvidencni) {
                houseNumber = ' č. ev.' + houseNumber
                if (ul) {
                    ul += ','
                }
            }

            ul += houseNumber
            words.push(ul)
        }

        else if (subject.uliceKompletni) {
            words.push(subject.uliceKompletni)
        }

        if (type === 'townFirst') {
            let townFirstString = ''

            if (subject.obec) {
                townFirstString += subject.obec
            }
            if (subject.obec && words[0]) {
                townFirstString += ', '
            }
            if (subject.ulice || houseNumber) {
                if (subject.ulice && subject.ulice !== subject.obec) {
                    townFirstString += subject.ulice + ' '
                }
                townFirstString += houseNumber
            }
            return townFirstString
        }

        else if (type === 'simple') {
            let obecAndPsc = ''
            if (subject.obec) {
                obecAndPsc += subject.obec
            }
            if (subject.psc) {
                obecAndPsc += ' ' + subject.psc
            }
            if (obecAndPsc) {
                words.push(obecAndPsc)
            }
        }

        else {
            if (subject.castObce && subject.castObce !== subject.obec) {
                words.push(subject.castObce)
            }
            if (subject.mestskaCast && subject.mestskaCast !== subject.obec) {
                words.push(subject.mestskaCast)
            }
            if (subject.obec) {
                words.push(subject.obec)
            }
            if (subject.psc) {
                words.push(subject.psc)
            }
        }

        if (subject.stat) {
            words.push(subject.stat)
        }

        return words.join(', ')
    }
}